<div class="relative inline-block">
    <div class="flex flex-row items-center gap-2">
        <p class="text-nside-orange-400 font-semibold whitespace-nowrap">
            Need Assistance?
        </p>
        <button 
            (click)="$event.preventDefault(); openChatbox();"
            class="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white shadow-custom-2"
        >  
            <lucide-icon [name]="icons.Lightbulb"></lucide-icon>
        </button>
    </div>
    <!-- Content Box -->
    <div 
        *ngIf="showChatbox"
        class="content absolute w-96 h-88 bg-white right-5 rounded-xl border border-nside-orange-300 shadow-lg z-20 flex flex-col justify-between shadow-custom-2"
    >
        <div class="p-2 rounded-t-xl bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 flex items-center justify-between">
            <h3 class="text-white oswald-font text-lg text-center ms-2">EOP Assistant</h3>
            <button 
                class="p-0.5 rounded-full hover:bg-white/20"
                (click)="$event.preventDefault(); onClose();"
            >
                <lucide-icon [name]="icons.Minus" [size]="24" class="text-white"></lucide-icon>
            </button>
        </div>
        <div class="overflow-y-auto p-4 h-full flex flex-row items-start justify-start gap-2">
            <div class="w-8 h-8">
                <button 
                    class="w-8 h-8 flex items-center justify-center text-nside-orange-400"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb">
                        <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                        <path d="M9 18h6" />
                        <path d="M10 22h4" />
                    </svg>
        </button>
            </div>
            <div class="w-full flex flex-col justify-start gap-2">
                <div class="w-fit h-full p-2 rounded-tl-xl rounded-br-xl rounded-tr-xl rounded-bl shadow-chat-dialog">
                    <p>Here are some suggestions:</p>
                </div>
                <div 
                    *ngIf="loading"
                    class="w-full p-2 rounded-bl-xl rounded-tr-xl rounded-br-xl rounded-tl shadow-chat-dialog animate-pulse"
                >
                    <div class="m-3 h-1 bg-gray-300 rounded-full w-2/3"></div>
                    <div class="m-3 w-1/3 h-1 bg-gray-200 rounded-full"></div>
                </div>
                <div
                    *ngIf="suggestion===''"
                    class="w-full p-2 rounded-bl-xl rounded-tr-xl rounded-br-xl rounded-tl shadow-chat-dialog">
                    <p>No EOP Suggestions found</p>
                </div>
                <div                     
                    *ngIf="suggestion!==''"
                    class="w-full p-2 rounded-bl-xl rounded-tr-xl rounded-br-xl rounded-tl shadow-chat-dialog"
                >
                    <p>{{ suggestion }}</p>
                </div>
            </div>
        </div>
        <div class="p-4 flex items-center justify-end">
            <button 
                (click)="$event.preventDefault(); getSuggestion();"
                class="p-2 flex items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-sm"
            >
                Re-generate
            </button>
        </div>
    </div>
</div>
